import { agentProductionTerms as apt } from "../../constants";
import { COLOR_PRIMARY_GREEN, COLOR_SECONDARY_GREEN, COLOR_TERTIARY_GREEN } from "../../common/constants/colors";

export const terms = Object.freeze({
    activeForSale: 'Active (For Sale)',
    dom: 'DOM',
    avgCdom: 'Average CDOM',
    avgDom: 'Average DOM',
    avgDomCdom: 'Average DOM-CDOM',
    avgPrice: 'Average Price',
    avgPriceSqft: 'Average $/SQFT',
    avgPricePerSqft: 'per SQFT',
    avgPriceSqftLabel: (status) => `${status} $/SQFT`,
    avgSpLpComparison: 'Average SP/LP Comparison',
    avgSpOp: 'Avg SP/OP',
    avgSpOpAllComparison: 'Average SP/OP Comparison',
    avgSpOpAllProperties: 'Average SP/OP All Properties',
    avgSpOpComparison: 'Average SP/OP Comparison',
    bathrooms: 'Bathrooms',
    begin: 'begin',
    beginVsEndMonthLabel: 'Begin vs. End Month',
    beginPeriod: (selectedBeginValue) => `Begin: ${selectedBeginValue}`,
    cdomBreakout: 'CDOM Breakout',
    cdom: 'CDOM',
    change: 'Change',
    change$: '$ Change',
    changePct: '% Change',
    custom: 'custom',
    days: 'Days',
    daysChange: 'Days Change',
    end: 'end',
    endPeriod: (selectedEndValue) => `End: ${selectedEndValue}`,
    expAvgDom: 'Expired Avg Dom',
    expAvgPricePerSqft: 'Expired $/Sqft',
    expAvgSqft:'Avg Sqft Expired',
    expAvgVolume: 'Avg Expired $',
    expired: 'Expired',
    expMedianVolume: 'Expired Median $',
    expUnits: '# Expired',
    forSale: 'For Sale',
    forSaleAvgDom: 'For Sale Avg Dom',
    forSaleAvgPricePerSqft: 'For Sale $/Sqft',
    forSaleAvgSqft:'Avg Sqft For Sale',
    forSaleAvgVolume: 'Avg For Sale $',
    forSaleLastDayUnits: '# For Sale Last Day of Month',
    forSaleLastDayUnitsTip: 'The number of listings that were for sale on the last day of the month',
    forSaleMedianVolume: 'For Sale Median $',
    forSaleUnits: '# For Sale',
    forSaleUnitsParens: 'For Sale (Units)',
    forSaleVolumeParens: 'For Sale (Volume)',
    forSaleVsFsldm: 'For Sale vs. FSLDM',
    forSaleLdm: 'For Sale Last Day of the Month',
    fsldm: 'FSLDM',
    forSaleLastDayChangeVolume: '# For Sale - # For Sale Last Day Difference',
    forSaleLastDayChangeVolumeTip: 'Difference between the number of listings that were for sale during the month and the number of listings that were for sale on the last day of the month',
    percentDifference: '% Difference',
    percentDifferenceTip: 'Difference between the number of listings that were for sale during the month and the number of listings that were for sale on the last day of the month as a percentage of the number of listings for sale during the month',
    itemTypeCount: (itemType, countOfItems) => `${itemType} (${countOfItems})`,
    lastWeeksAvg: 'Last 12 weeks avg',
    lastWeeksAvgTip: 'The average for the last 12 weeks',
    listingViews: 'Listing Views',
    medianPrice: 'Median Price',
    medianPriceChange: 'Median price change',
    medianPriceSold: 'Median Price (Sold)',
    month: 'Month',
    monthly: 'Monthly',
    monthlySupplyOfInventory: 'Monthly Supply of Inventory',
    months: 'Months',
    monthsSupply: 'Months Supply',
    msiChange: 'MSI Change',
    msiSold: 'MSI-Sold',
    newAvgPricePerSqft: 'New $/Sqft',
    newAvgSqft:'Avg Sqft New',
    newAvgVolume: 'Avg New $',
    newListings: 'New Listings',
    newMedianVolume: 'New Listing Median $',
    newUnits: '# New Listed',
    offMarketDate: 'Off Market Date',
    orgPrice: 'Org. Price',
    overview: 'Overview',
    pdf: 'PDF',
    percentage: 'Percentage',
    periodChange: (period) => `${period} Change`,
    periodPercentChange: (period) => `${period} % Change`,
    previousWeeksAvg: 'Prev 12 weeks avg',
    previousWeeksAvgTip: 'The average for the previous 12 weeks',
    price: 'Price',
    pricePerSqft: '$/SQFT',
    quarter: 'Quarter',
    quarterly: 'Quarterly',
    salesAbsorption: 'Sales Absorption',
    salesPriceOriginalPrice: 'Sales Price / Original Price',
    salesRate: 'Sales Rate',
    sold: 'Sold',
    soldAvgDom: 'Sold Avg Dom',
    soldAvgDomWithoutPriceChanges: 'Avg DOM - No Price Changes',
    soldAvgDomWithPriceChanges:'Avg DOM - 1+ Price Changes',
    soldAvgPricePerSqft: 'Sold $/Sqft',
    soldAvgSqft: 'Avg Sqft Sold',
    soldAvgVolume: 'Avg Sold $',
    soldAvgVsMedianPrice: 'Sold Average vs. Median Price',
    soldChangeVolume: 'Average $ - Median $',
    soldGrowthVolumePct: 'Median $ as % of Average $',
    soldMedianVolume: 'Sold Median $',
    soldPercentage: '% Sold',
    soldUnits: '# Sold',
    soldUnitsParens: 'Sold (Units)',
    soldUnitsWithoutPriceChanges:'# Sold - No Price Changes',
    soldUnitsWithPriceChanges: '# Sold - 1+ Price Changes',
    soldVolumeParens: 'Sold (Volume)',
    spLp: 'SP/LP',
    spLpNoPriceChanges: 'SP/LP No Price Changes',
    spLpPriceChanges: 'SP/LP 1+ Price Changes',
    spLpRatioWithoutPriceChanges: 'Avg SP/LP - No Price Changes',
    spLpRatioWithPriceChanges: 'Avg SP/LP - 1+ Price Changes',
    spOp: 'SP/OP',
    spOpNoPriceChanges: 'SP/OP No Price Changes',
    spOpPriceChanges: 'SP/OP 1+ Price Changes',
    spOpRatioWithoutPriceChanges: 'Avg SP/OP - No Price Changes',
    spOpRatioWithPriceChanges: 'Avg SP/OP - 1+ Price Changes',
    status: 'status',
    sqFt: 'Sq Ft',
    supplyAmpDemand: 'Supply & Demand',
    supplyAmpDemandNumUnits: 'Supply & Demand - # Units',
    timePeriodStart: 'Period',
    totalChange: 'Total Change',
    totalPercentChange: 'Total % Change',
    ucAvgDom: 'Under Contract Avg Dom',
    ucAvgPricePerSqft: 'Under Contract $/Sqft',
    ucAvgSqft:'Avg Sqft Under Contract',
    ucAvgVolume: 'Avg Under Contract $',
    ucMedianVolume: 'Under Contract Median $',
    ucPercentage: '% Under Contract',
    ucUnits: '# Under Contract',
    ucUnitsParens: 'Under Contract (Units)',
    ucVolumeParens: 'Under Contract (Volume)',
    underContract: 'Under Contract',
    underContractMsi: 'MSI-Under Contract',
    underContractUc: 'Under Contract (UC)',
    units: 'Units',
    units0To90: '0 - 90',
    units0To90Cdom: '0 - 90 CDOM',
    units0To90CdomPct: '0 - 90 CDOM %',
    units91To180: '91 - 180',
    units91To180Cdom: '91 - 180 CDOM',
    units91To180CdomPct: '91 - 180 CDOM %',
    unitsChangeNum: '# Units Change',
    unitsNum: '# Units',
    unitsOver180: '181+',
    unitsOver180Cdom: '181+ CDOM',
    unitsOver180CdomPct: '181+ CDOM %',
    weekLabel: (week) => `W${week}`,
    week: 'Week',
    weekly: 'Weekly',
    weekOf: 'Week Of',
    wholeTimePeriodLabel: 'Whole Time Period',
    yAxisDollarChartTitle: 'Dollars in Thousands',
    msi: 'MSI',
    loneWolfMarketDynamics: 'Lone Wolf Market Dynamics',
    report: 'Report',
    monthlySupplyOfInventoryMSI: 'Monthly Supply of Inventory (MSI)',
    totalInventoryVolume: 'Total Inventory ($)',
    totalInventoryUnit: 'Total Inventory (#)',
    increase: 'Increase',
    decrease: 'Decrease',
    sellers: "Seller's",
    buyers: "Buyer's",
    neutral: 'Neutral',
    getMarketTypeText: (marketType) => `It's a ${marketType} Market!`,
    getListingTitle: title => `${apt.listings} (${title})`,
    buyersMarketDescription: 'Homes are typically on the market for more than 6 months before selling, which suggests buyers may face less competition, and sellers might be more flexible on terms and conditions.',
    neutralMarketDescription: 'Homes are typically selling within 4 to 6 months, indicating a stable market.',
    sellersMarketDescription: 'Homes are typically selling in under 4 months. This means buyers may face more competition for properties they love and should consider making more competitive offers.',
    loneWolfMarketShare: 'Lone Wolf Market Share',
    loneWolfProficiencyMetrics: 'Lone Wolf Proficiency Metrics',
    getBySearchTypeTitle: (searchType) => `By ${searchType}`,
    loneWolfAgentProduction: 'Lone Wolf Agent Production', 
});

export const errorMessaging = Object.freeze({
    cannotBeEmptyObject: "Invalid parameter: cannot be an empty object.",
    convertToPdf: 'Error converting to PDF:',
    fetchOffices: 'Error fetching offices',
    getFetchErrorMsg: fetchItem => `Error fetching ${fetchItem}`
});

export const periodKeys = Object.freeze({
    beginPeriodValue: 'beginPeriodValue',
    endPeriodValue: 'endPeriodValue',
    beginVsEndMonth: 'beginVsEndMonth',
    wholeTimePeriod: 'wholeTimePeriod',
});

export const measureTypeKeys = Object.freeze({
    percent: 'percent',
    unit: 'unit',
    volume: 'volume'
});

export const measureTypeByConfigKey = Object.freeze({
    headerTooltipPercentType: measureTypeKeys.percent,
    headerTooltipUnitType: measureTypeKeys.unit,
});

export const barChartColors = Object.freeze({
    first: COLOR_PRIMARY_GREEN,
    second: COLOR_SECONDARY_GREEN,
    third: COLOR_TERTIARY_GREEN,
    firstTransparency: 'rgba(35, 104, 71, 0.2)',
    secondTransparency: 'rgba(101, 150, 127, 0.2)',
    thirdTransparency: 'rgba(167, 195, 181, 0.2)',
    pureWhite: '#fff',
});

export const marketDynamicsColors = {
    bars: [barChartColors.first, barChartColors.second, barChartColors.third],
    barsTransparency: [
        barChartColors.firstTransparency,
        barChartColors.secondTransparency,
        barChartColors.thirdTransparency
    ]
};

export const chartFontFamily =
    '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,' +
    'sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"';

export const chartLabelStyles = {
    colors: ['#111827'],
    fontFamily: chartFontFamily,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
};

export const getYAxisTitle = (title) => ({
    text: title,
    style: { ...chartLabelStyles, fontWeight: 600, colors: ['#6B7280'] }
});

export const measureTypes = Object.freeze({ units: 'units' });

export const officeBreakdownTab = 0;

export const marketTypes = Object.freeze({
    sellers: 'sellers',
    buyers: 'buyers',
    neutral: 'neutral',
});

export const marketDynamicsTableViewNames = Object.freeze({
    avgPriceSqft: 'avgPriceSqft',
    avgDomCdom: 'avgDomCdom',
    avgSpLpComparison: 'avgSpLpComparison',
    avgSpOpAllProperties: 'avgSpOpAllProperties',
    avgSpOpComparison: 'avgSpOpComparison',
    cdomBreakout: 'cdomBreakout',
    forSaleVsFsldm: 'forSaleVsFsldm',
    medianPrice: 'medianPrice',
    monthlySupplyOfInventory: 'monthlySupplyOfInventory',
    salesAbsorption: 'salesAbsorption',
    soldAvgVsMedianPrice: 'soldAvgVsMedianPrice',
    supplyAmpDemandNumUnits: 'supplyAmpDemandNumUnits',
    underContractUc: 'underContractUc',
    newListings: 'newListings',
    forSale: 'forSale',
    forSaleLdm: 'forSaleLdm',
    underContract: 'underContract',
    sold: 'sold',
    expired: 'expired',
});
